export default {
  PLATE_PATTERN: /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼][A-Z](([A-HJ-NP-Z\d]{4}[A-HJ-NP-Z\d警学挂港澳临试超])|([A-Z][A-HJ-NP-Z\d]{5})|([A-HJ-NP-Z\d]{5}[A-Z]))))$/i,
  NEW_ENERGY_PLATE: /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼][A-Z](([A-Z][A-HJ-NP-Z\d]{5})|([A-HJ-NP-Z\d]{5}[A-Z])))$/i,
  PHONE_11: /^(\+\d{2}[- ])?(0\d{2,3}[- ])?(\d{11})$/i,
  PHONE_8: /^(\+\d{2}[- ])?(0\d{2,3}[- ])?(\d{8})$/i,
  PHONE_ALL: /^(\+\d{2}[- ])?(0\d{2,3}[- ])?(\d{11}|\d{8})$/i,
  idCard: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
};
